<template>
  <div>
    <div class="flex mb-6 text-center">
      <p class="text-sm">
        <span>
          {{$t('frontend_groovemail_campaigns_wizard_broadcasts_campaign_campaign_content_sub_heading_part_a') }}
        </span>
        <span
          class="
            cursor-pointer
            text-primary
            font-bold
          "
          @click="redirectToCLosemSignupPage"
        >
          closem.ai
        </span>
        <span>
          {{$t('frontend_groovemail_campaigns_wizard_broadcasts_campaign_campaign_content_sub_heading_part_b') }}
        </span>
        <span
          v-if="fetchClosemIntegeration()"
          class="
            cursor-pointer
            font-bold text-primary
          "
          @click="redirectToCLosemDashboard"
        >
          {{ $t('frontend_groovemail_campaigns_create_postal_integration_postal_click_here_to_create_postals') }}
        </span>
      </p>
    </div>
    <div
      class="flex justify-center mb-6"
      v-if="!fetchClosemIntegeration()"
    >
      <gd-button
        variant="primary"
        size="auto"
        @click="redirectToCLosemSignupPage"
      >
        {{ $t('frontend_groovemail_campaigns_create_postal_integration_postal_signup_closem') }}
      </gd-button>
    </div>
    <div class="step1 mb-6" v-if="fetchClosemIntegeration()">
      <div class="activeicon mb-2">
        <p class="font-semibold text-base text-dark">
          {{ $t('frontend_groovemail_campaigns_wizard_broadcasts_campaign_postal_content_label') }}
        </p>
      </div>
      <div class="flex border-grey-300 mt-2">
        <div class="w-full flex flex-no-wrap flex-col">
          <div class="w-full relative">
            <DownIcon class="h-5 w-5 absolute right-2 text-grey-600 top-2.5"/>
            <select
              @change="onPostalCampaignChange($event)"
              v-model="localModel.postalSequenceId"
              class="w-full h-10 rounded-lg text-sm border border-grey-200 text-dark bg-white pl-3 pr-7 appearance-none"
            >
              <option value disabled>
                {{ $t('frontend_select') }}
              </option>
              <option
                v-for="(campaign, index) in postalCampaigns"
                :data-name="campaign.title"
                :key="index"
                :value="campaign.id"
              >
                {{ campaign.title }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import auth from '@groovepages/gd-lib/auth';
import showAlert from '@/components/sweet-alert-popup.js';
import themeConfig from '@/theme/themeConfig';

// import icons
import DownIcon from '@/assets/images/icons/new/down_new.svg';

export default {
  name: 'PostalNode',
  props: {
    model: {
      required: true,
    },
  },

  data() {
    return {
      localModel: this.model,
      currentstep: 1,
      postalCampaigns: [],
    };
  },

  components: {
    DownIcon,
  },

  methods: {
    onPostalCampaignChange(e) {
      this.localModel.postalCampaign =
        e.target.options[e.target.options.selectedIndex].dataset.name;
    },

		async fetchPostalCampaigns() {
      try {
        const postalCampaigns = await axios.get('/postal/broadcast');
        if (postalCampaigns.data.status.toLowerCase() === 'fail') {
          this.showErrorMessage('frontend_groovemail_campaigns_create_postal_integration_invalid');
          this.postalCampaigns = [];
        } else if (
          postalCampaigns &&
          postalCampaigns.data &&
					postalCampaigns.data.response &&
					postalCampaigns.data.response.campaigns &&
					postalCampaigns.data.response.campaigns.length
        ) {
          this.postalCampaigns = postalCampaigns.data.response.campaigns;
        }
      } catch (err) {
				this.$emit('hideLoader');
        this.postalCampaigns = [];
      }
    },

    showErrorMessage(errorMessage) {
      showAlert({
        iconType: 'alert-error',
        html : `
          <style>.swal2-confirm { color: ${themeConfig.appPrimaryColorInvert} !important; }</style>
          <p class="text-sm text-deep-dark"> ${ this.$t(errorMessage) }</p>
        `,
        showCancelButton: false,
        showCloseButton: true,
        confirmButtonColor: themeConfig.appPrimaryColor,
        confirmButtonText: this.$t(
          'frontend_close'
        ),
      });
    },

    redirectToCLosemDashboard() {
      window.open('https://app.closem.ai/index.php?m=campaigns');
    },

    redirectToCLosemSignupPage() {
      const user = auth.authenticatedUser();
      window.open(`${'https://groove.closem.ai/?fpr=groove'}&name=${user.name}&email=${user.email}&phone=`);
    },

    fetchClosemIntegeration() {
      let integrations = [];
      const user = auth.authenticatedUser();
      if (user.metadata && user.metadata.integrations) {
        integrations = user.metadata.integrations.filter(
          ele => ele.type === 'closem-integration'
        );
      }
      if (integrations && integrations.length) {
        return integrations[integrations.length - 1].id;
      }
      return 0;
    },
  },

  async created() {
		this.$emit('showLoader');
    if (this.fetchClosemIntegeration()) {
      await this.fetchPostalCampaigns();
    }
		this.$emit('hideLoader');
  },

  watch: {
    localModel() {
      this.$emit('updateModel', this.localModel);
    },
  },
};
</script>